import {useAlive} from '@github-ui/use-alive'
import throttle from 'lodash-es/throttle'
import {useMemo} from 'react'

const THROTTLE_INTERVAL_MS = 2000

/**
 * Hook that subscribes to branch alive updates and triggers the appropriate refetch callback.
 *
 * @param aliveChannel - The signed alive channel for the branch
 * @param onBranchUpdate - Callback to trigger when an update occurs
 */
export function useBranchAliveUpdates(aliveChannel: string | undefined, onBranchUpdate: () => void) {
  const throttledBranchRefetch = useMemo(
    () => throttle(onBranchUpdate, THROTTLE_INTERVAL_MS, {leading: false, trailing: true}),
    [onBranchUpdate],
  )

  const handleAliveEvent = () => {
    throttledBranchRefetch()
  }

  useAlive(aliveChannel, handleAliveEvent)
}
